import { Api as apiService } from '../api';
export class AutomatedRemindersApi {
    static createAutomatedReminder(automatedReminder) {
        return apiService.responseToJSONAndToastError(apiService.post(`${AutomatedRemindersApi.automatedRemindersApi}`, automatedReminder));
    }
    static updateAutomatedReminder(automatedReminderId, automatedReminder) {
        return apiService.responseToJSONAndToastError(apiService.patch(`${AutomatedRemindersApi.automatedRemindersApi}/${automatedReminderId}`, automatedReminder));
    }
    static getSingleAutomatedReminder(automatedReminderId) {
        return apiService.responseToJSONAndToastError(apiService.get(`${AutomatedRemindersApi.automatedRemindersApi}/${automatedReminderId}`));
    }
    static getAllAutomatedReminder() {
        return apiService.responseToJSONAndToastError(apiService.get(`${AutomatedRemindersApi.automatedRemindersApi}`));
    }
    static deleteAutomatedReminder(automatedReminderId) {
        return apiService.responseToJSONAndToastError(apiService.delete(`${AutomatedRemindersApi.automatedRemindersApi}/${automatedReminderId}`));
    }
}
AutomatedRemindersApi.automatedRemindersApi = `/api/automated_reminders`;
